import './AppTemplate.css'

import { compose, withProps, withState } from 'recompose'
import { Link, withRouter } from 'react-router-dom'
import React from 'react'
import AppBar from 'material-ui/AppBar'
import Drawer from 'material-ui/Drawer'
import Menu from 'material-ui/Menu'
import MenuItem from 'material-ui/MenuItem'
import muiThemeable from 'material-ui/styles/muiThemeable'
import { negate } from 'lodash'

import NewVersionPrompt from './NewVersionPrompt'
import {
  aboutRoute,
  chatRoute,
  indexRoute,
  programRoute,
  reportProblemRoute,
  sponsorsRoute,
  trackRoute,
  venueRoute,
  exhibitorsRoute,
} from '../app/routes'
import { getAppTitle, getNavigationLabels, getTracks } from '../app/selectors'
import { withSizes } from '../app/utils'
import content from '../content'
import { isTrackCrossTrack } from '../app/predicates'

// disable swipe of drawer as swipe is also used for back (e.g. iOS)
const DISABLE_SWIPE = true

const TrackItem = ({ color, label }) => (
  <div className="AppTemplate-TrackItem-container">
    <div
      style={{ backgroundColor: color }}
      className="AppTemplate-TrackItem-icon"
    />
    {label}
  </div>
)

const titleStyle = {
  cursor: 'pointer',
}

const AppTemplate = ({
  isDrawerOpen,
  setDrawerOpen,
  children,
  location,
  title,
  isDesktop,
  navigationLabels,
  tracks,
  muiTheme,
  history,
}) => {
  const openDrawer = () => setDrawerOpen(true)
  const closeDrawer = () => setDrawerOpen(false)
  const { backgroundColor } = muiTheme.custom.colors
  const {
    appBar: { height: appBarHeight },
    custom: { metrics: { basePadding, maxContentWidth } },
  } = muiTheme
  const contentStyle = {
    margin: isDesktop ? '0 0 0 280px' : '0',
    padding: basePadding,
    paddingTop: appBarHeight + basePadding,
    maxWidth: maxContentWidth,
  }
  const navigateHome = () => history.push(indexRoute)
  return (
    <div className="AppTemplate-container" style={{ backgroundColor }}>
      <AppBar
        title={title}
        onTitleClick={navigateHome}
        titleStyle={titleStyle}
        onLeftIconButtonClick={openDrawer}
        style={{ position: 'fixed' }}
      />
      <div className="AppTemplate-content" style={contentStyle}>
        {children}
      </div>
      <Drawer
        open={isDesktop || isDrawerOpen}
        docked={isDesktop}
        containerStyle={{ overflow: 'hidden', backgroundColor }}
        onRequestChange={open => setDrawerOpen(open)}
        disableSwipeToOpen={DISABLE_SWIPE}
      >
        <AppBar
          title={title}
          onTitleClick={navigateHome}
          titleStyle={titleStyle}
          showMenuIconButton={!isDesktop}
          onLeftIconButtonClick={closeDrawer}
        />
        <Menu value={location.pathname} onItemClick={closeDrawer}>
          <MenuItem
            value={programRoute}
            containerElement={<Link to={programRoute} />}
            primaryText={navigationLabels.program}
          />
          {tracks.filter(negate(isTrackCrossTrack)).map(t => (
            <MenuItem
              key={t.id}
              style={{ paddingLeft: 20 }}
              value={trackRoute(t.id)}
              containerElement={<Link to={trackRoute(t.id)} />}
            >
              <TrackItem color={t.color} label={t.label} />
            </MenuItem>
          ))}
          <MenuItem
            value={chatRoute}
            containerElement={<Link to={chatRoute} />}
            primaryText={navigationLabels.chat}
          />
          <MenuItem
            value={venueRoute}
            containerElement={<Link to={venueRoute} />}
            primaryText={navigationLabels.venue}
          />
          <MenuItem
            value={aboutRoute}
            containerElement={<Link to={aboutRoute} />}
            primaryText={navigationLabels.about}
          />
          <MenuItem
            value={sponsorsRoute}
            containerElement={<Link to={sponsorsRoute} />}
            primaryText={navigationLabels.sponsors}
          />
          <MenuItem
            value={exhibitorsRoute}
            containerElement={<Link to={exhibitorsRoute} />}
            primaryText={navigationLabels.exhibitors}
          />
          <MenuItem
            value={reportProblemRoute}
            containerElement={<Link to={reportProblemRoute} />}
            primaryText={navigationLabels.reportProblem}
          />
        </Menu>
      </Drawer>
      <NewVersionPrompt />
    </div>
  )
}

const withDrawerState = withState('isDrawerOpen', 'setDrawerOpen', false)
const withPageContent = withProps({
  title: getAppTitle(content),
  navigationLabels: getNavigationLabels(content),
  tracks: getTracks(content),
})

export default compose(
  withRouter,
  withDrawerState,
  withPageContent,
  withSizes(),
  muiThemeable()
)(AppTemplate)



// WEBPACK FOOTER //
// ./src/components/AppTemplate.js